'use strict';

function shouldProcessEveryNode(node) {
  return true;
}
module.exports = {
  shouldProcessEveryNode: shouldProcessEveryNode
};